// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + {"95":"325f11984101d760911a","141":"6815f3bb31455a13eb17","235":"18a49c08eb2b5e25dab3","360":"1d5a44ac86f75ece05b9","842":"ec5ab05a8631e0be2354"}[chunkId] + ".chunk.js";
};